module.exports = __webpack_public_path__ + "static/media/gateway.60195d1d.png";